var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-progress-bar",on:{"click":_vm.onClick}},[_c('div',{staticClass:"bar"},[_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.getText()))]),_vm._v(" "),_c('div',{staticClass:"progress-fon"},[_c('div',{staticClass:"progress",style:({width: _vm.getValue()+'%'})})])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ea6dc80","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-progress-bar/src/ui-progress-bar.vue
// module id = 713
// module chunks = 0